<div class="container-fluid mt-3 department-page">
    <div class="mb-3">
    <button class="btn btn-outline-secondary" (click)="goBack()">
      <i class="fas fa-arrow-left me-2"></i> Back to Dashboard
    </button>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h3 class="dept-title mb-1">RFR Responsible Employees</h3>
      <small class="text-muted">
        Showing {{ filteredRfrList.length }} of {{ rfrList.length }} Departments
      </small>
    </div>
  </div>

  <div class="card dept-filter-card mb-3">
    <div class="card-body py-2">
      <div class="row align-items-center g-2">
        <div class="col-md-6">
          <div class="input-group dept-search-box">
            <span class="input-group-text">
              <i class="fas fa-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Search by department or employee name"
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilters()"
            />
          </div>
        </div>
        <div class="col-md-6 text-md-end mt-2 mt-md-0">
          <!-- <span class="badge badge-light text-muted dept-summary-pill">
            <i class="fas fa-user-tie me-1"></i>
            {{ filteredRfrList.length }} visible
          </span> -->
        </div>
      </div>
    </div>
  </div>

  <div class="card dept-card">
    <div *ngIf="isLoading" class="dept-loading-overlay">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status"></div>
        <div class="mt-2 text-muted small">Loading RFR data...</div>
      </div>
    </div>

    <div class="card-body p-0">
      <div *ngIf="!isLoading && loadError" class="alert alert-danger m-3">
        {{ loadError }}
      </div>

      <div *ngIf="!isLoading && !loadError && filteredRfrList.length === 0" class="alert alert-info m-3">
        No records found. Try changing the filters.
      </div>

      <div class="table-responsive" *ngIf="!isLoading && !loadError && filteredRfrList.length > 0">
        <table class="table table-hover mb-0 dept-table">
          <thead class="thead-light">
            <tr>
              <th style="width: 40%;">Department Name</th>
              <th style="width: 40%;">RFR Responsible Employee</th>
              <th style="width: 20%;" class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of filteredRfrList; trackBy: trackByRfr"
              (click)="onRowClick(item)"
              class="dept-row"
            >
              <td class="align-middle">
                <div class="fw-bold dept-name">
                  <i class="fas fa-sitemap text-muted me-1"></i>
                  {{ item.department_name || '-' }}
                </div>
              </td>
              <td class="align-middle">
                <div>
                  <i class="fas fa-user-tie text-muted me-1"></i>
                  {{ item.rfr_responsible_employee_name || 'Not assigned' }}
                </div>
              </td>
              <td class="align-middle text-end">
                <button class="btn btn-edit" (click)="editRfr(item); $event.stopPropagation()">
                  <i class="fas fa-edit"></i> Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>